import './index.css';

export type {HeaderProps} from './Header';
export {default as default} from './Header';
export {getDefaultHeaderProps} from './config';
